module.exports = __webpack_public_path__ + "static/media/bg-profissionais-rh.c981cbfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Intro/bg-profissionais-rh.jpg
// module id = 272
// module chunks = 0